import { Injectable } from '@angular/core';
import { MwHttpService } from '@core/http';
import { MwLoadOptionsService } from './utils/load-options.service';
import { MwLoadOptions } from 'app/models/load-options.model';
import { Observable } from 'rxjs';
import {
  DeliveriesResponseModel,
  DeliveryApiModel,
} from 'app/models/delivery-api.model';
import { AssignmentLoadPriorityEnum } from 'app/models/assignment-api.model';

@Injectable({ providedIn: 'root' })
export class MwDeliveriesApiService {
  constructor(
    private http: MwHttpService,
    private loadOptionsService: MwLoadOptionsService
  ) {}

  private endpoint = `/transport/v1/Companies/{companyId}/Deliveries`;

  load(options?: MwLoadOptions): Observable<DeliveriesResponseModel> {
    let query = options ? this.loadOptionsService.buildQuery(options) : '';
    query = query.length ? `?${query}` : '';
    return this.http.authGet<DeliveriesResponseModel>(
      `${this.endpoint}${query}`
    );
  }

  create(delivery: DeliveryApiModel): Observable<DeliveryApiModel> {
    this.fillNonNullableFields(delivery);
    return this.http.authPost<DeliveryApiModel>(`${this.endpoint}`, {
      body: delivery,
    });
  }

  update(delivery: DeliveryApiModel): Observable<DeliveryApiModel> {
    this.fillNonNullableFields(delivery);
    return this.http.authPut<any>(`${this.endpoint}`, {
      body: delivery,
    });
  }

  delete(delivery: DeliveryApiModel): Observable<DeliveryApiModel> {
    return this.http.authDelete<DeliveryApiModel>(`${this.endpoint}`, {
      body: delivery,
    });
  }

  changeStatuses(
    ids: number[],
    newStatus: string
  ): Observable<DeliveryApiModel> {
    return this.http.authPut<any>(`${this.endpoint}/ChangeStatuses`, {
      body: { ids, newStatus },
    });
  }

  private fillNonNullableFields(delivery: DeliveryApiModel): void {
    delivery.quantity = delivery.quantity || 0;
    delivery.distance = delivery.distance || 0;
    delivery.isReturnDelivery = delivery.isReturnDelivery || false;
    delivery.loadingTimePriority =
      delivery.loadingTimePriority || AssignmentLoadPriorityEnum.none;
    delivery.unloadingTimePriority =
      delivery.unloadingTimePriority || AssignmentLoadPriorityEnum.none;
  }
}
